// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w-md-editor-toolbar {
  border-bottom: 1px solid #dfdfe0;
  background-color: #fbfbfb;
  padding: 4px 2px 4px 5px;
  border-radius: 3px 3px 0 0;
  -webkit-user-select: none;
          user-select: none;
}
.w-md-editor-toolbar ul,
.w-md-editor-toolbar li {
  margin: 0;
  padding: 0;
  list-style: none;
}
.w-md-editor-toolbar li {
  display: inline-block;
  font-size: 14px;
}
.w-md-editor-toolbar li > button {
  border: none;
  height: 20px;
  line-height: 14px;
  background: none;
  color: #586069;
  padding: 4px;
  margin: 0 1px;
  border-radius: 2px;
  text-transform: none;
  font-weight: normal;
  overflow: visible;
  outline: none;
  cursor: pointer;
  transition: all 0.3s;
}
.w-md-editor-toolbar li > button:hover,
.w-md-editor-toolbar li > button:focus {
  color: #06c;
  background-color: #dcdcdc;
}
.w-md-editor-toolbar li > button:active {
  color: #6a57ff;
  background-color: #dcdcdc;
}
.w-md-editor-toolbar li > button:disabled {
  color: #ccc;
  cursor: not-allowed;
}
.w-md-editor-toolbar li > button:disabled:hover {
  background-color: transparent;
  color: #ccc;
}
.w-md-editor-toolbar li.active > button {
  color: #06c;
  background-color: #e8e8e8;
}
.w-md-editor-toolbar-divider {
  height: 14px;
  width: 1px;
  margin: -3px 3px 0 3px !important;
  vertical-align: middle;
  background-color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@uiw/react-md-editor/lib/esm/components/Toolbar/index.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,yBAAyB;UACjB,iBAAiB;AAC3B;AACA;;EAEE,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,oBAAoB;AACtB;AACA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,sBAAsB;EACtB,sBAAsB;AACxB","sourcesContent":[".w-md-editor-toolbar {\n  border-bottom: 1px solid #dfdfe0;\n  background-color: #fbfbfb;\n  padding: 4px 2px 4px 5px;\n  border-radius: 3px 3px 0 0;\n  -webkit-user-select: none;\n          user-select: none;\n}\n.w-md-editor-toolbar ul,\n.w-md-editor-toolbar li {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n.w-md-editor-toolbar li {\n  display: inline-block;\n  font-size: 14px;\n}\n.w-md-editor-toolbar li > button {\n  border: none;\n  height: 20px;\n  line-height: 14px;\n  background: none;\n  color: #586069;\n  padding: 4px;\n  margin: 0 1px;\n  border-radius: 2px;\n  text-transform: none;\n  font-weight: normal;\n  overflow: visible;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n.w-md-editor-toolbar li > button:hover,\n.w-md-editor-toolbar li > button:focus {\n  color: #06c;\n  background-color: #dcdcdc;\n}\n.w-md-editor-toolbar li > button:active {\n  color: #6a57ff;\n  background-color: #dcdcdc;\n}\n.w-md-editor-toolbar li > button:disabled {\n  color: #ccc;\n  cursor: not-allowed;\n}\n.w-md-editor-toolbar li > button:disabled:hover {\n  background-color: transparent;\n  color: #ccc;\n}\n.w-md-editor-toolbar li.active > button {\n  color: #06c;\n  background-color: #e8e8e8;\n}\n.w-md-editor-toolbar-divider {\n  height: 14px;\n  width: 1px;\n  margin: -3px 3px 0 3px !important;\n  vertical-align: middle;\n  background-color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
